const lines = [
  { x1: 5, y1: 18, x2: 26, y2: 24, alt: false },
  { x1: 26, y1: 24, x2: 42, y2: 16, alt: true },
  { x1: 42, y1: 16, x2: 61, y2: 22, alt: false },
  { x1: 61, y1: 22, x2: 82, y2: 12, alt: true },
  { x1: 12, y1: 45, x2: 31, y2: 38, alt: true },
  { x1: 31, y1: 38, x2: 48, y2: 46, alt: false },
  { x1: 48, y1: 46, x2: 66, y2: 40, alt: true },
  { x1: 66, y1: 40, x2: 88, y2: 48, alt: false },
  { x1: 18, y1: 76, x2: 34, y2: 66, alt: false },
  { x1: 34, y1: 66, x2: 56, y2: 74, alt: true },
  { x1: 56, y1: 74, x2: 74, y2: 68, alt: false },
  { x1: 74, y1: 68, x2: 93, y2: 78, alt: true },
  { x1: 24, y1: 24, x2: 31, y2: 38, alt: false },
  { x1: 48, y1: 46, x2: 56, y2: 74, alt: true },
  { x1: 61, y1: 22, x2: 66, y2: 40, alt: false },
  { x1: 82, y1: 12, x2: 88, y2: 48, alt: true },
];

const nodes = [
  { cx: 5, cy: 18, r: 0.85, bright: false },
  { cx: 26, cy: 24, r: 1.1, bright: true },
  { cx: 42, cy: 16, r: 0.95, bright: false },
  { cx: 61, cy: 22, r: 1.15, bright: true },
  { cx: 82, cy: 12, r: 0.9, bright: false },
  { cx: 12, cy: 45, r: 0.85, bright: false },
  { cx: 31, cy: 38, r: 1.2, bright: true },
  { cx: 48, cy: 46, r: 1.1, bright: false },
  { cx: 66, cy: 40, r: 1.05, bright: true },
  { cx: 88, cy: 48, r: 0.95, bright: false },
  { cx: 18, cy: 76, r: 0.8, bright: false },
  { cx: 34, cy: 66, r: 1, bright: true },
  { cx: 56, cy: 74, r: 1.05, bright: false },
  { cx: 74, cy: 68, r: 1.15, bright: true },
  { cx: 93, cy: 78, r: 0.88, bright: false },
];

const SignalField = () => {
  return (
    <div className="signal-field">
      <svg className="signal-svg" viewBox="0 0 100 100" preserveAspectRatio="none">
        {lines.map((line) => (
          <line
            key={`${line.x1}-${line.y1}-${line.x2}-${line.y2}`}
            className={`signal-line${line.alt ? " signal-line--alt" : ""}`}
            x1={line.x1}
            y1={line.y1}
            x2={line.x2}
            y2={line.y2}
          />
        ))}

        {nodes.map((node) => (
          <g key={`${node.cx}-${node.cy}`}>
            <circle className="signal-blur" cx={node.cx} cy={node.cy} r={node.r * 3.8} />
            <circle
              className={`signal-node${node.bright ? " signal-node--bright" : ""}`}
              cx={node.cx}
              cy={node.cy}
              r={node.r}
            />
          </g>
        ))}
      </svg>
    </div>
  );
};

export default SignalField;